import React, { useMemo } from 'react';
import { Button, Dropdown, message, Tooltip } from 'antd';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import { ReactComponent as More } from '@assets/icons/MediaViewer/more.svg';
import { ReactComponent as LinkSvg } from '@assets/icons/dropdown/link.svg';
import { ReactComponent as CopySvg } from '@assets/icons/copy-secondary.svg';
import { ReactComponent as SuccessSvg } from '@assets/icons/success.svg';
import { useGetApprovalWorkflow } from '@hooks/queries/approval';

import './ApprovalAssetsListActionMenu.less';

type ApprovalAssetsListActionMenuProps = {
  approvalWorkflowId?: string;
  password?: string | null;
};

function ApprovalAssetsListActionMenu({
  approvalWorkflowId,
  password
}: ApprovalAssetsListActionMenuProps) {
  const { data } = useGetApprovalWorkflow({
    enabled: false,
    params: {
      id: approvalWorkflowId || '',
      password
    }
  });
  const approvalWorkflow = data?.approvalWorkflow;

  const menuItems = useMemo((): ItemType[] => {
    if (!approvalWorkflow) return [];
    return [
      {
        key: 'copy-approval-link',
        icon: <LinkSvg className="b-icon-copy-link" />,
        label: (
          <Tooltip
            overlayClassName="toggle_favorite_overlay"
            title="Only reviewers in this approval can access this link"
            placement="right"
          >
            <span>Copy approval link</span>
          </Tooltip>
        ),
        onClick: () => {
          navigator.clipboard.writeText(approvalWorkflow.url);
          message.success({
            content: 'Copied link to clipboard',
            className: 'message-dark-modal',
            icon: <SuccessSvg className="anticon" />
          });
        }
      },
      {
        key: 'copy-approval-id',
        icon: <CopySvg className="b-icon-copy" />,
        label: 'Copy Approval ID',
        onClick: () => {
          navigator.clipboard.writeText(approvalWorkflow.id);
          message.success({
            content: 'Approval ID copied to clipboard',
            className: 'message-dark-modal',
            icon: <SuccessSvg className="anticon" />
          });
        }
      }
    ];
  }, [approvalWorkflow]);

  if (!approvalWorkflow) return null;

  return (
    <Dropdown
      menu={{
        items: menuItems,
        selectable: false
      }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="approval-assets-list-action-menu-overlay"
    >
      <Button className="media_viewer_btn b-only-icon">
        <More />
      </Button>
    </Dropdown>
  );
}

export default ApprovalAssetsListActionMenu;
